<script>
import { mapMutations } from 'vuex';
import { eventBus } from 'EventBus/';
import { busName as variantSelectorBus } from 'Directives/variant-selector/variant-selector';
export default {
  name: 'sustainability',
  props: {
    initialData: {
      type: Object,
      required: true,
    },
    disableRecyclable: {
      type: Object,
      required: true,
    },
    productPage: { type: Boolean, require: false, default: false },
    collapseTitle: { type: String, require: false },
    collapseIcon: { type: String, require: false },
    stickerScoreText: { type: String, default: '' },
    readMoreText: { type: String, default: '' },
    isEbs: { type: Boolean, require: false, default: false }
  },
  data() {
    return {
      selectedVariant: null,
      footnotes: null,
      popupTitle: null,
      PopupDes: null,
      isModalVisible: false,
    };
  },

  computed: {
    // analyticsData() {
    //   return {
    //     event: 'uaevent',
    //     ecommerce: undefined,
    //     eventCategory: 'product detail page',
    //     eventAction: 'select::sustainability',
    //     eventLabel: this.initialData.ProductName.replace('&apos;', "'"),
    //   };
    // },
    // sustainabilityAnalyticsData() {
    //   return {
    //     event: 'uaevent',
    //     ecommerce: undefined,
    //     eventCategory: 'product detail page',
    //     eventAction: 'select::sustainability::recommended product',
    //     eventLabel:
    //       this.selectedVariant.Alternativeproductoption.match(
    //         /<a [^>]+>([^<]+)<\/a>/
    //       ) === null
    //         ? ''
    //         : this.selectedVariant.Alternativeproductoption.match(
    //             /<a [^>]+>([^<]+)<\/a>/
    //           )[1],
    //   };
    // },
    // sustainabilityReplacementAnalyticsData() {
    //   return {
    //     event: 'uaevent',
    //     ecommerce: undefined,
    //     eventCategory: 'product detail page',
    //     eventAction: 'select::sustainability::replacement product',
    //     eventLabel:
    //       this.selectedVariant.ReplacementProductOption.match(
    //         /<a [^>]+>([^<]+)<\/a>/
    //       ) === null
    //         ? ''
    //         : this.selectedVariant.ReplacementProductOption.match(
    //             /<a [^>]+>([^<]+)<\/a>/
    //           )[1],
    //   };
    // },
  },
  watch: {
    selectedVariant(values) {
      let data = values;
      data.stickerScoreText = this.stickerScoreText;
      data.readMoreText = this.readMoreText;
      this.SET_PIL_STICKER_DETAILS(values);
    },
  },
  mounted() {
    this.setSelectedVariant();
    /* istanbul ignore next*/
    // window.eventBus.$on('variantChange', (payload) => {
    //   this.selectedVariant = this.findVariant(payload);
    //   this.createFootnotesArray();
    // });
    eventBus.$on(`${variantSelectorBus}::selected`, (payload) => {
      this.selectedVariant = this.findVariant(payload);
      if (this.isEbs) {        
        this.initializeUpdateEAN(this.selectedVariant);
      }
      this.createFootnotesArray();
    });
  },

  methods: {
    ...mapMutations('productDetail', ['SET_PIL_STICKER_DETAILS']),
    closeModal() {
      this.isModalVisible = false;
    },
    sustainabilityPopup(title, des, value) {
      this.popupTitle = title;
      this.PopupDes = des;
      this.isModalVisible = true;
      if (this.initialData.Analytics) {
        const sustainpopuptagging = Object.assign(
          {},
          this.initialData.Analytics
        );
        sustainpopuptagging.eventLabel = value.toLowerCase();
        try {
          window.dataLayer.push(sustainpopuptagging);
        } catch (event) {
          console.warn('datalayer is not defined');
        }
      }
    },
    createFootnotesArray() {
      this.footnotes = Object.keys(this.selectedVariant).filter((key) =>
        key.includes('Footnote')
      );
      if (
        !this.selectedVariant.MadeAtSubcontractorPlant &&
        this.disableRecyclable.value == ''
      ) {
        for (let i = 0; i < this.footnotes.length; i++) {
          if (this.footnotes[i] == 'Footnote4') {
            this.footnotes.splice(i, 1);
          }
        }
      }
      if (
        !this.selectedVariant.MadeAtSubcontractorPlant &&
        this.selectedVariant.Footnote5 == ''
      ) {
        this.footnotes.pop();
      } else if (
        !this.selectedVariant.MadeAtSubcontractorPlant &&
        this.selectedVariant.Footnote5 != ''
      ) {
        this.footnotes.splice(2, 1);
      }
    },
    setSelectedVariant() {
      const variantOnLoad = this.initialData.SelectedVariant;

      this.selectedVariant = this.findVariant(variantOnLoad);
      if (this.isEbs) {
        this.initializeUpdateEAN(this.selectedVariant);
      }
      this.createFootnotesArray();
    },

    findVariant(searchedVariant) {
      return this.initialData.ProductSustainabilityDetails.Variants.filter(
        (variant) => {
          return variant.VariantId === searchedVariant;
        }
      )[0];
    },

     // Call the function to set the initial EAN number
     initializeUpdateEAN(EAN) {
      if (typeof window.RefApp?.DSF?.SetEANNumber === 'function') {
        window.RefApp.DSF.SetEANNumber(EAN)
      }
    },

    // triggerGA() {
    //   try {
    //     window.dataLayer.push(this.analyticsData);
    //   } catch (error) {
    //     console.warn(error);
    //   }
    // },
    // triggerGASustainablity() {
    //   try {
    //     window.dataLayer.push(this.sustainabilityAnalyticsData);
    //   } catch (error) {
    //     console.warn(error);
    //   }
    // },
    // triggerGASustainablityReplacement() {
    //   try {
    //     window.dataLayer.push(this.sustainabilityReplacementAnalyticsData);
    //   } catch (error) {
    //     console.warn(error);
    //   }
    // },
  },
};
</script>
